import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Warning icon for alert
 *
 * @author Arish Kumar K
 */
const Warning = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path fill="currentcolor" d="M13.559459,1.91844891 L23.7769385,20.3590868 C24.2534332,21.2190706 23.9414416,22.3018852 23.0800857,22.7776209 C22.8159921,22.9234825 22.5191252,23 22.2173157,23 L1.78235667,23 C0.797988264,23 -1.11022302e-14,22.2032829 -1.11022302e-14,21.2204825 C-1.11022302e-14,20.9191537 0.076639574,20.6227597 0.222733909,20.3590868 L10.4402134,1.91844891 C10.9167082,1.05846511 12.0012504,0.746970493 12.8626062,1.22270621 C13.1557674,1.38462214 13.3972847,1.62575473 13.559459,1.91844891 Z M11.5,9 C11.2238576,9 11,9.22385763 11,9.5 L11,15.5 C11,15.7761424 11.2238576,16 11.5,16 L12.5,16 C12.7761424,16 13,15.7761424 13,15.5 L13,9.5 C13,9.22385763 12.7761424,9 12.5,9 L11.5,9 Z M11.5,18 C11.2238576,18 11,18.2238576 11,18.5 L11,19.5 C11,19.7761424 11.2238576,20 11.5,20 L12.5,20 C12.7761424,20 13,19.7761424 13,19.5 L13,18.5 C13,18.2238576 12.7761424,18 12.5,18 L11.5,18 Z" />
  </SvgIcon>
);

export default Warning;
